import icons from '@bonanza-social/moonlight/lib/assets/icons';
import { PromoTargetSchema } from '@bonanza-social/promos';
import { z } from '@bonanza-social/toolkit/api';

export const rewardBadgeMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof typeof icons>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'bonanzaCoin',
  InstantWheel: 'rewardWheel',
  Cash: 'bonanzaDollar',
  Bonus: 'bonanzaCoin',
};
